module.exports = __webpack_public_path__ + "d725c0948bf962da8f31fa39844ac5aa.png";